// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusOutlinedSvg from "@ant-design/icons-svg/es/asn/MinusOutlined";
import AntdIcon from '../components/AntdIcon';

var MinusOutlined = function MinusOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusOutlinedSvg
  }));
};

MinusOutlined.displayName = 'MinusOutlined';
export default React.forwardRef(MinusOutlined);